import { Controller } from "@hotwired/stimulus"

// Used to provide interaction for tabs where the content for all tabs is pre-loaded onto the page,
// and we just need to hide/show as appropriate.
export default class extends Controller {
  connect() {
    this.handles = this.element.querySelectorAll('[data-tab-handle]')
    this.bodies = this.element.querySelectorAll('[data-tab-body]')
    for (var i = 0; i < this.handles.length; i++) {
      var handle = this.handles[i];
      handle.addEventListener('click', this.onClick.bind(this));
    }

    // Support deep-linking via the URL hash. Only act when the hash matches a
    // tab body id so pages that render a non-default initial tab are unaffected.
    var hash = window.location.hash.replace(/^#/, '');
    if (!hash) return;
    for (var j = 0; j < this.handles.length; j++) {
      if (this.handles[j].getAttribute('data-target') === hash) {
        this.activate(this.handles[j]);
        return;
      }
    }
  }

  onClick(e) {
    e.preventDefault();
    this.activate(e.currentTarget);
  }

  activate(clickedHandle) {
    var tabBodyId = clickedHandle.getAttribute('data-target');
    for (var i = 0; i < this.bodies.length; i++) {
      var body = this.bodies[i];
      if (body.id == tabBodyId) {
        body.classList.remove('hidden');
      } else {
        body.classList.add('hidden');
      }
    }

    // Update clicked tab to be active. We toggle both the Tailwind utility
    // classes (used by most tab bars) and a generic `active` class so callers
    // can style the active handle via their own CSS instead.
    clickedHandle.classList.add('active', 'font-bold', 'border-b-2', 'border-core-purple-500', 'mb-[-1px]');
    clickedHandle.classList.remove('text-support-dark-600');

    // Update other tabs to be inactive
    for (var i = 0; i < this.handles.length; i++) {
      var handle = this.handles[i];
      if (handle != clickedHandle) {
        handle.classList.remove('active', 'font-bold', 'border-b-2', 'border-core-purple-500', 'mb-[-1px]');
        handle.classList.add('text-support-dark-600');
      }
    }
  }
}
